/**
 * Do not edit directly
 * Generated on Wed, 22 Feb 2023 03:49:41 GMT
 */

export const colours = {
  grey: {
    '50': '#f8f9f9',
    '100': '#ededed',
    '200': '#c8c8c8',
    '300': '#a8a8a8',
    '400': '#8b8b8b',
    '500': '#6a6a6a',
    '600': '#464646',
    '700': '#333333',
    '800': '#1f1f1f',
    '900': '#000000',
  },
  slate: {
    '50': '#f8f9fa',
    '100': '#e9eaee',
    '200': '#C4C7D0',
    '300': '#A3A8B6',
    '400': '#848A9D',
    '500': '#626A82',
    '600': '#3B4662',
    '700': '#2B3348',
    '800': '#1B1F2C',
    '900': '#000000',
  },
  brand: {
    primary: {
      '50': '#f8f9fa',
      '100': '#e9eaee',
      '200': '#C4C7D0',
      '300': '#A3A8B6',
      '400': '#848A9D',
      '500': '#626A82',
      '600': '#3B4662',
      '700': '#2B3348',
      '800': '#1B1F2C',
      '900': '#000000',
    },
    secondary: {
      '50': '#f8f9fa',
      '100': '#e9eaee',
      '200': '#C4C7D0',
      '300': '#A3A8B6',
      '400': '#848A9D',
      '500': '#626A82',
      '600': '#3B4662',
      '700': '#2B3348',
      '800': '#1B1F2C',
      '900': '#000000',
    },
  },
  base: {
    content: {
      default: '#2B3348',
      strong: '#1B1F2C',
      medium: '#3B4662',
      brand: '#626A82',
      inverse: '#ffffff',
    },
    canvas: {
      default: '#ffffff',
      alt: '#f8f9f9',
      backdrop: '#ededed',
      'brand-subtle': '#f8f9fa',
      inverse: '#1f1f1f',
      overlay: 'rgba(31, 31, 31, 0.8)',
    },
    divider: {
      subtle: '#f8f9f9',
      medium: '#ededed',
      strong: '#c8c8c8',
      inverse: '#ffffff',
      brand: '#626A82',
    },
  },
  interaction: {
    main: {
      default: '#000000',
      hover: '#3B4662',
      active: '#2B3348',
    },
    links: {
      default: '#000000',
      hover: '#2B3348',
      'neutral-default': '#333333',
      'neutral-hover': '#000000',
      'inverse-default': '#ffffff',
      'inverse-hover': '#ededed',
    },
    'main-subtle': {
      default: '#e9eaee',
      hover: '#C4C7D0',
      active: '#A3A8B6',
    },
    sub: {
      default: '#626A82',
      hover: '#3B4662',
      active: '#2B3348',
    },
    'sub-subtle': {
      default: '#e9eaee',
      hover: '#C4C7D0',
      active: '#A3A8B6',
    },
    critical: {
      default: '#c03434',
      hover: '#992a2a',
      active: '#852424',
    },
    'critical-subtle': {
      default: '#FBE9E9',
      hover: '#f4acac',
      active: '#ee8080',
    },
    warning: {
      default: '#FFDA68',
      hover: '#E2B73E',
      active: '#C4992A',
    },
    'warning-subtle': {
      default: '#fffae1',
      hover: '#FFDA68',
      active: '#E2B73E',
    },
    success: {
      default: '#0F796F',
      hover: '#0C5F57',
      active: '#0A524B',
    },
    'success-subtle': {
      default: '#E2EEED',
      hover: '#98CCC7',
      active: '#63B1AA',
    },
    neutral: {
      default: '#6a6a6a',
      hover: '#464646',
      active: '#333333',
    },
    'neutral-subtle': {
      default: '#f8f9f9',
      hover: '#ededed',
      active: '#c8c8c8',
    },
    muted: {
      main: {
        hover: '#f8f9fa',
        active: '#e9eaee',
      },
      sub: {
        hover: '#f8f9fa',
        active: '#e9eaee',
      },
      critical: {
        hover: '#fef7f7',
        active: '#FBE9E9',
      },
      neutral: {
        hover: '#f8f9f9',
        active: '#ededed',
      },
    },
    tinted: {
      main: {
        hover: 'rgba(98, 106, 130, 0.04)',
        active: 'rgba(98, 106, 130, 0.12)',
      },
      sub: {
        hover: 'rgba(98, 106, 130, 0.04)',
        active: 'rgba(98, 106, 130, 0.12)',
      },
      critical: {
        hover: 'rgba(192, 52, 52, 0.04)',
        active: 'rgba(192, 52, 52, 0.12)',
      },
      neutral: {
        hover: 'rgba(0, 0, 0, 0.1)',
        active: 'rgba(0, 0, 0, 0.2)',
      },
      inverse: {
        hover: 'rgba(255, 255, 255, 0.1)',
        active: 'rgba(255, 255, 255, 0.2)',
      },
    },
    support: {
      unselected: '#a8a8a8',
      selected: '#6a6a6a',
      'unselected-strong': '#6a6a6a',
      disabled: '#ededed',
      'disabled-content': '#a8a8a8',
      placeholder: '#a8a8a8',
    },
  },
  blue: {
    '50': '#F7F9FE',
    '100': '#E7EFFC',
    '200': '#ACC7FA',
    '300': '#82ABF7',
    '400': '#568DF4',
    '500': '#1361F0',
    '600': '#0D4FCA',
    '700': '#0B44AC',
    '800': '#093890',
    '900': '#072A69',
  },
  red: {
    '50': '#fef7f7',
    '100': '#FBE9E9',
    '200': '#f4acac',
    '300': '#ee8080',
    '400': '#e74f4f',
    '500': '#c03434',
    '600': '#992a2a',
    '700': '#852424',
    '800': '#721f1f',
    '900': '#571717',
  },
  green: {
    '50': '#F5FAFA',
    '100': '#E2EEED',
    '200': '#98CCC7',
    '300': '#63B1AA',
    '400': '#2D978C',
    '500': '#0F796F',
    '600': '#0C5F57',
    '700': '#0A524B',
    '800': '#09463F',
    '900': '#073430',
  },
  yellow: {
    '50': '#fffae1',
    '100': '#FFDA68',
    '200': '#E2B73E',
    '300': '#C4992A',
    '400': '#A77C18',
    '500': '#8B6005',
    '600': '#704C00',
    '700': '#624200',
    '800': '#533800',
    '900': '#3f2b00',
  },
  standard: {
    white: '#ffffff',
    black: '#000000',
  },
  skin: {
    '1base': '#FFCAA4',
    '1shadow': '#F5B896',
    '2base': '#EBA687',
    '2shadow': '#E29B7B',
    '3base': '#D98F6F',
    '3shadow': '#CE8361',
    '4base': '#BF7657',
    '4shadow': '#AF6D53',
    '5base': '#9F634F',
    '5shadow': '#8B5544',
    '6base': '#764738',
    '6shadow': '#633D32',
  },
  utility: {
    feedback: {
      info: '#1361F0',
      'info-subtle': '#F7F9FE',
      warning: '#FFDA68',
      'warning-subtle': '#fffae1',
      success: '#0F796F',
      'success-subtle': '#F5FAFA',
      critical: '#c03434',
      'critical-subtle': '#fef7f7',
    },
    'focus-default': '#1361F0',
    'focus-inverse': '#ffffff',
    'input-prefilled': '#fffae1',
    ui: '#ffffff',
    'ui-clear': 'rgba(255, 255, 255, 0)',
  },
}
